import { ChangePasswordModel } from './../../models/change-password.model';
import { RegisterUserModel } from './../../models/register-user.model';
export class IsAuthorized {
  static readonly type = '[Account-State] Is Authorized';
  constructor(public isAuthorized: boolean) {}
}

export class SetTitle {
  static readonly type = '[Account-State] Set Title';
  constructor(public title: string) {}
}

export class ChangePassword {
  static readonly type = '[Account-State] Change password';
  constructor(public model: ChangePasswordModel) {}
}

export class RegisterUser {
  static readonly type = '[Account-State] Register user';
  constructor(public model: RegisterUserModel) {}
}

export class SetAccount {
  static readonly type = '[Account-State] Set user';
  constructor(public model: RegisterUserModel) {}
}

export class GetAccountFromCache {
  static readonly type = '[Account-State] Get user';
  constructor() {}
}

export class UpdateAccount {
  static readonly type = '[Account-State] Update user';
  constructor(public model: RegisterUserModel) {}
}

export class SelectAccount {
  static readonly type = '[Account-State] Select account';
  constructor(public id: string) {}
}
